import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { TDR, querySnapshotToArray } from 'tdr-common';

const CACHE_SETTINGS = {
	staleTime: 5 * 60 * 1000, // 5 minutes - table data rarely changes
	gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache
	refetchOnMount: false,
	refetchOnWindowFocus: false
};

export function useTableBySlug(restaurantId: string, tableSlug: string) {

	const query = useQuery({
		enabled: !!tableSlug && !!restaurantId,
		queryKey: ['getTableSlug', restaurantId, tableSlug],
		queryFn: () => getTableSlug(restaurantId, tableSlug),
		...CACHE_SETTINGS
	});

	return query;
}

export async function getTableSlug(
	restaurantId: string,
	tableSlug: string
): Promise<TDR.Table | null> {
	try {
		const db = getFirestore();
		const q = query(
			collection(db, 'Tables'),
			where('slug', '==', tableSlug),
			where('restaurantId', '==', restaurantId)
		);
		const querySnapshot = await getDocs(q);
		const results = querySnapshotToArray(querySnapshot);
		const filteredResults = results.filter((table: { deleted?: any; }) => !table.deleted);
		return filteredResults[0] || null;
	}
	catch (error) {
		console.error('Error getting table by slug', error);
		return null;
	}
}
